import {AlarmActionsHeader, SignTable} from "../utils/alarms-actions-ui.jsx";
const VerticalTableCard = ({name, data, className}) => {
  function parseJson(value) {
    if (!value) return null;
    if (typeof value !== "string") return value;

    try {
      return JSON.parse(value);
    } catch {
      return null;
    }
  }

  const sign1 = parseJson(data?.sign1);
  const sign2 = parseJson(data?.sign2);
  const hasAssumeData = data?.assumename !== null && data?.assumename !== undefined && data?.assumename !== "";

  return(
    <div className={["w-full print:break-inside-avoid", className].join(" ")}>
      <AlarmActionsHeader header={name}/>
      <div className="border border-[#505050] p-2">
        { hasAssumeData
          ? <>
            <table className="text-[14px]">
              <thead>
              <tr>
                <td className="border border-[#e7e7e7] border-collapse text-[#4f4f4f]! bg-[#fafafa] text-center">
                  <span className="font-bold text-[12.25px]">ASSUMIU O ALARME: </span>
                  <span className="font-bold">{data?.assumename}</span>
                </td>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td className="border border-[#e7e7e7] border-collapse text-[#4f4f4f]! bg-[#fafafa] text-center">
                  <span className="font-bold text-[12.25px]">Auto-assumir alarmes relacionados: </span>
                  <span className="font-bold">{data?.autoassumed ? "Sim" : "Não"}</span>
                </td>
              </tr>
              </tbody>
            </table>
            <div className="flex gap-4 mt-16">
              <SignTable name="AÇÃO TOMADA - 1ª FASE" data={sign1} sign={data?.usersign1 ?? ""}/>
              <SignTable name="AÇÃO TOMADA - 2ª FASE" data={sign2} sign={data?.usersign2 ?? ""}/>
            </div>
          </>
          : <div className="text-center">Sem dados para exibir</div>
        }
      </div>
    </div>
  )
}

export default VerticalTableCard;